import type { Expert } from '@packages/shared/core/experts/entities';

const DEFAULT_JOB_TITLE = 'Psychic';

export const getExpertJobTitle = (expert: Expert): string => {
  return expert.specialization || expert.specializations?.[0]?.name || DEFAULT_JOB_TITLE;
};
